import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)


export default new Router({
	mode :'history',
	  routes: [
	    {
	      path: '/',
	      name: 'home',
	      meta : {
	      	index : 0,
	      	childshow: 0,
	      },      
	      component: () => import('@/view/index/index')
	    },
	    {
	      path: '/index',      
	      name: 'index',
	      meta : {
	      	index : 1,	
	      	childshow: 0,
	      },   
	      component: () => import('@/view/index/index')
	    },
	    {
	      path: '/projects',      
	      name: 'projects',
	      meta : {
	      	index : 2,	
	      	childshow: 0,
	      },   
	      component: () => import('@/view/projects/index')
	    },
	    {
	      path: '/ceo',      
	      name: 'ceo',
	      meta : {
	      	index : 3,
	      	childshow: 1,
	      },   
	      component: () => import('@/view/ceo/index')
	    },
	    {
	      path: '/company',      
	      name: 'about',
	      meta : {
	      	index : 4,
	      	childshow: 1,
	      },   
	      component: () => import('@/view/about/index')
	    },
	    {
	      path: '/corporate_idea',      
	      name: 'corporate_idea',
	      meta : {
	      	index : 5,	
	      	childshow: 1,
	      },   
	      component: () => import('@/view/about/corporate_idea')
	    },
	    {
	      path: '/organizational',      
	      name: 'organizational',
	      meta : {
	      	index : 6,	
	      	childshow: 1,
	      },   
	      component: () => import('@/view/about/organizational')
	    },
	    {
	      path: '/events',      
	      name: 'events',
	      meta : {
	      	index : 7,	
	      	childshow: 1,
	      },   
	      component: () => import('@/view/about/events')
	    },
	    {
	      path: '/aboutnews',      
	      name: 'news',
	      meta : {
	      	index : 8,
	      	childshow: 1,
	      },   
	      component: () => import('@/view/about/news')
	    },{
	      path: '/fengmao',      
	      name: 'fengmao',
	      meta : {
	      	index : 8,
	      	childshow: 1,
	      },   
	      component: () => import('@/view/about/fenmao')
	    },
	    {
	      path: '/services',      
	      name: 'services',
	      meta : {
	      	index : 10,	
	      	childshow: 0,
	      },   
	      component: () => import('@/view/services/index')
	    },
	    {
	      path: '/eliteteam',      
	      name: 'teamIndex',
	      meta : {
	      	index : 11,
	      	childshow: 1,
	      },   
	      component: () => import('@/view/team/index')
	    },
	    {
	      path: '/teamdesign',      
	      name: 'design',
	      meta : {
	      	index : 12,	
	      	childshow: 1,
	      },   
	      component: () => import('@/view/team/design'),
	    },
	    {
	      path: '/culture',      
	      name: 'culture',
	      meta : {
	      	index : 14,
	      	childshow: 0,
	      },   
	      component: () => import('@/view/culture/index')
	    },
	    {
	      path: '/enterprise',      
	      name: 'enterprise',
	      meta : {
	      	index : 15,	
	      	childshow: 0,
	      },   
	      component: () => import('@/view/joinus/index')
	    },
	    {
	      path: '/joinus',      
	      name: 'joinus',
	      meta : {
	      	index : 15,	
	      	childshow: 0,
	      },   
	      component: () => import('@/view/joinus/index')
	    },{
	      path: '/contact',      
	      name: 'contact',
	      meta : {
	      	index : 16,
	      	childshow: 0,
	      },   
	      component: () => import('@/view/contact/index')
	    },
	    {
	      path: '/cooperation',      
	      name: 'cooperation',
	      meta : {
	      	index : 17,	
	      	childshow: 0,
	      },   
	      component: () => import('@/view/cooperation/index')
	    },
	    {
	      path: '/partner_two',      
	      name: 'partner',
	      meta : {
	      	index : 18,	
	      	childshow: 1,
	      },   
	      component: () => import('@/view/cooperation/partner'),
	    },{
	      path: '/branch_new',      
	      name: 'branch',
	      meta : {
	      	index : 19,	
	      	childshow: 1,
	      },   
	      component: () => import('@/view/cooperation/branch'),
	    },
	]
})



// WEBPACK FOOTER //
// ./src/router/index.js